<template>
  <v-app-bar app color="primary" flat dense clipped-left>
    <v-app-bar-nav-icon @click.stop="$root.drawer = !$root.drawer" />
    <v-toolbar-title>{{ $root.appTitle }}</v-toolbar-title>
    <div>
      <v-img contain src="/img/T_logo.png" height="39px" max-width="200px" />
    </div>
    <div>
      <v-img
        contain
        src="/img/logo_nwt_new.png"
        height="56px"
        max-width="200px"
      />
    </div>
    <v-spacer />
    <v-toolbar-items>
      <NotificationsMenu />
      <UserMenu />
    </v-toolbar-items>
  </v-app-bar>
</template>

<script>
import UserMenu from '@/Components/Layout/UserMenu'
import NotificationsMenu from '@/Components/Layout/NotificationsMenu'

export default {
   name: 'Appbar',
   components: {
      UserMenu,
      NotificationsMenu,
   },
}
</script>
